import { Component, ViewContainerRef } from '@angular/core';
import { Router ,NavigationEnd} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import { CustomObserverService } from './shared/';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

import { ToastsManager } from 'ng2-toastr/ng2-toastr';

declare let ga:Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {

  public title = '';

  constructor(router: Router, private customObserverService: CustomObserverService,private translateService:TranslateService, titleService:Title, private toastr: ToastsManager, vRef: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vRef);
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        ga('set', 'page', event.urlAfterRedirects);
        ga('send', 'pageview');
      }
    });
 
    titleService.setTitle("Grade5 : පහේ ශිෂ්‍යත්වය");

    this.customObserverService.className$.subscribe(value => {
      window.document.body.className = value;
    });

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    // translateService.use('si');
    // console.log("app component");
    // if(this.cookieManagerService.getCookie("Lang", false)){
    //   this.translateService.use(this.cookieManagerService.getCookie("Lang", false));
    // }
    // else{
    //   this.translateService.use("si");
    // }

  }

  
}
 



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/app.component.ts